import { formatDecimal, type FormatOptions } from '../lib/decimal';
import { reasonText } from '../i18n/reasons.hu';

/** A missing value: always "—" with the reason (tooltip + screen-reader text), never 0. */
export function Dash({ reason }: { reason?: string | null }) {
  const text = reasonText(reason);
  return (
    <span className="muted" title={text} data-testid="null-value">
      —<span className="sr-only"> ({text})</span>
    </span>
  );
}

interface ValProps extends FormatOptions {
  value: string | null | undefined;
  reason?: string | null;
  unit?: string | null;
  className?: string;
}

/** Decimal string -> formatted text, or "—" + reason when null. */
export function Val({ value, reason, unit, className, ...fmt }: ValProps) {
  if (value === null || value === undefined) return <Dash reason={reason} />;
  return (
    <span className={className}>
      {formatDecimal(value, fmt)}
      {unit ? ` ${unit}` : ''}
    </span>
  );
}

/** Sign colour for result-like numbers. */
export function signClass(value: string | null | undefined): string {
  if (!value) return '';
  if (/^-\s*0*(\.0*)?$/.test(value)) return '';
  if (value.startsWith('-')) return 'neg';
  return /^\+?0*(\.0*)?$/.test(value) ? '' : 'pos';
}
